import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { useTheme } from "styled-components";
import { genericColor } from "~/lib/resolvers";
const StyledLink = styled.button`
  text-align: left;
  background-color: transparent;
  border: none;
  display: ${_ref => {
  let {
    $display
  } = _ref;
  return $display;
}};
  cursor: pointer;
  transition: color 200ms ease-out;
  color: ${_ref2 => {
  let {
    $color,
    theme
  } = _ref2;
  return genericColor(theme, $color);
}};
  z-index: 1;
  position: relative;
  font-size: ${_ref3 => {
  let {
    $fontSize,
    theme
  } = _ref3;
  return $fontSize ? `${theme.typography.fontStep * $fontSize}rem` : "inherit";
}};
  ${_ref4 => {
  let {
    $weight,
    theme
  } = _ref4;
  return $weight && `font-weight: ${theme.typography.fontWeight[$weight]}`;
}};
  ${_ref5 => {
  let {
    $underline
  } = _ref5;
  return $underline ? `text-decoration: underline` : `text-decoration: none`;
}};
  ${_ref6 => {
  let {
    $s,
    theme
  } = _ref6;
  return theme.spacing.resolve(theme, $s);
}};
  word-break: break-word;

  &:hover {
    color: ${_ref7 => {
  let {
    $color
  } = _ref7;
  return $color;
}}d9;
  }

  &:visited {
    color: ${_ref8 => {
  let {
    $color
  } = _ref8;
  return $color;
}}d9;
  }
`;
const Link = _ref9 => {
  let {
    href,
    s,
    underline = false,
    display = "inline",
    color = "secondary",
    weight,
    fontSize,
    children,
    ...rest
  } = _ref9;
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    as: href ? "a" : "button",
    $s: s,
    $underline: underline,
    $display: display,
    $color: color || theme.colors.secondary.main,
    $weight: weight,
    $fontSize: fontSize,
    href: href,
    target: href ? "_blank" : undefined,
    type: href ? undefined : "button"
  }, rest), children);
};
export default Link;